(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('GitLabConfigController', GitLabConfigController);

    GitLabConfigController.$inject = ['GitLabConfig', 'Alerta', 'AlertService'];

    function GitLabConfigController(GitLabConfig, Alerta, AlertService) {
        var vm = this;

        vm.config = {
            url: '',
            token: ''
        };
        vm.exists = false;
        vm.maskedToken = null;
        vm.loading = true;
        vm.saving = false;

        vm.load = load;
        vm.save = save;
        vm.remove = remove;

        load();

        function load() {
            vm.loading = true;
            GitLabConfig.get().then(function (response) {
                vm.exists = true;
                vm.maskedToken = response.data.token;
                vm.config = {
                    url: response.data.url || '',
                    token: ''
                };
            }, function (error) {
                if (error.status === 404) {
                    vm.exists = false;
                    vm.maskedToken = null;
                    vm.config = {
                        url: '',
                        token: ''
                    };
                } else {
                    AlertService.error(error.data && error.data.message ? error.data.message : 'error.http.' + error.status);
                }
            }).finally(function () {
                vm.loading = false;
            });
        }

        function save() {
            if (!vm.config.url) {
                return;
            }
            if (!vm.exists && !vm.config.token) {
                Alerta.error('Atenção', 'O token é obrigatório na criação da configuração.');
                return;
            }

            var payload = {
                url: vm.config.url
            };
            if (vm.config.token) {
                payload.token = vm.config.token;
            }

            vm.saving = true;
            GitLabConfig.save(payload).then(function () {
                Alerta.success('Operação realizada', 'Configuração do GitLab salva com sucesso.');
                load();
            }, function (error) {
                AlertService.error(error.data && error.data.message ? error.data.message : 'error.http.' + error.status);
            }).finally(function () {
                vm.saving = false;
            });
        }

        function remove() {
            Alerta.confirm('Atenção', 'Tem certeza que deseja remover a configuração do GitLab?', 'warning', function () {
                GitLabConfig.remove().then(function () {
                    Alerta.success('Operação realizada', 'Configuração do GitLab removida.');
                    load();
                }, function (error) {
                    AlertService.error(error.data && error.data.message ? error.data.message : 'error.http.' + error.status);
                });
            }, angular.noop);
        }
    }
})();
